import Controller from "../controller/Controller";
import { ApmModalFrame } from "./ApmModalFrame";
import { ShowQrCodeParams } from "../types/actions";
import { ModalId } from "./inner/ModalId";
import { ShowAcceptAppParams } from "../types/actions/ShowAcceptAppParams";
import { getFrameAbsoluteUrl } from "../resourceUrls";

export type ModalCallbacks = {
    onClose?: () => void;
};

export type OpenedModal = {
    close: () => void;
};

export default class ApmModal {
    constructor(
        readonly _controller: Controller,
        readonly _publicKey: string
    ) { }

    showAcceptApp(params: ShowAcceptAppParams, modalCallbacks?: ModalCallbacks): { close: () => void } {
        return this.showModal<ShowAcceptAppParams>("acceptApp", params, modalCallbacks);
    }

    showQrCode(params: ShowQrCodeParams, modalCallbacks?: ModalCallbacks): { close: () => void } {
        return this.showModal<ShowQrCodeParams>("qrCode", params, modalCallbacks);
    }

    private showModal<TParams extends object>(modalId: ModalId, params: TParams, callbacks?: ModalCallbacks): OpenedModal {
        const frame = new ApmModalFrame(getFrameAbsoluteUrl(`apm/${modalId}.html`), this._controller._id, { ...params, isTestMode: this.isTestMode(), modalId });
        frame.appendTo(document.body);
        this._controller.addFrame(frame);

        const handleClose = () => frame.destroy();

        frame.on('apm-modal-close', () => {
            callbacks?.onClose?.();
            handleClose();
        });

        return {
            close: handleClose
        };
    }

    private isTestMode(): boolean {
        const result = /^[a-z]{2}_test_/.test(this._publicKey);
        if (typeof window !== 'undefined' && 'Cypress' in window) {
            const Cypress = window.Cypress as { env: (key: string) => any };
            return typeof Cypress.env('APM_MODAL_IS_TEST_MODE') === 'boolean' ? Cypress.env('APM_MODAL_IS_TEST_MODE') : result;
        }
        return result
    }
}
